export enum DescriptionColorEnum {
	'red' = 'red',
	'green' = 'green',
	'blue' = 'blue',
}

export interface IDescription {
	label: string | JSX.Element;
	value: number | string | JSX.Element;
	color: DescriptionColorEnum | JSX.Element;
	status?: boolean;
	onClick?: () => void;
}

export interface IYhBox {
	title?: string | JSX.Element;
	descriptions?: IDescription[];
	action?: JSX.Element;
	width?: string;
	height?: string;
	maxWidth?: string;
	maxHeight?: string;
	rightChildren?: JSX.Element;
	contentClass?: string;
	style?: React.CSSProperties;
}
